import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=64ca2ba4&scoped=true&"
import script from "./attention.vue?vue&type=script&lang=js&"
export * from "./attention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca2ba4",
  null
  
)

export default component.exports